export const requiredRule = {
  type: "required",
  message: "Поле не может быть пустым",
};
